import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  CoalitionHeroBanner,
  CoalitionSpinner,
  StarsBlock,
  StampsBlock,
  BannersBlock,
  ExtrasBlock,
  RewardsBlock,
  AwardsBlock,
} from "./../components";
import {
  getStampsCards,
  getRewardsCards,
  getAwardsCards,
  getExtraPointsCards,
  getBannersSlides,
  getStarsCards,
} from "../api";
import {
  tokenSolver,
  getFromStorage,
  stars,
  stamps,
  banners,
  extras,
  rewards,
  awards,
  putInStorage,
  privBalanceKey,
  privGtmKey,
} from "../utils";
import {
  sendTag,
  event_properties_101_01,
  event_properties_101_02,
  event_properties_101_07,
} from "../components/CoalitionGtm";
import "./DashboardPage.scss";

export const DashboardPage = () => {
  const gtm = localStorage.getItem(privGtmKey);
  useEffect(() => {
    if (gtm) sendTag(gtm, event_properties_101_01());
  }, [gtm]);

  const goToMovements = () => {
    if (gtm) sendTag(gtm, event_properties_101_02());
    return navigate(`/movements?${tokenSolver()}`);
  };

  const navigate = useNavigate();
  const balance = localStorage.getItem(privBalanceKey);

  // Stars
  const [loadingStars, setLoadingStars] = useState(false);
  const [starsCards, updateStarsCards] = useState([]);
  const fetchStars = () => {
    setLoadingStars(true);
    const oldResponse = getFromStorage(stars);
    if (oldResponse) updateStarsCards(oldResponse);
    setLoadingStars(false);
    return oldResponse ?? [];
  };

  // Stamps
  const [loadingStamps, setLoadingStamps] = useState(false);
  const [stampsCards, updateStampsCards] = useState([]);
  const fetchStamps = () => {
    setLoadingStamps(true);
    const oldResponse = getFromStorage(stamps);
    if (oldResponse) updateStampsCards(oldResponse);
    setLoadingStamps(false);
    return oldResponse ?? [];
  };
  // Banners
  const [loadingBannersSlides, setLoadingBannersSlides] = useState(false);
  const [bannersSlides, updateBannersSlides] = useState([]);
  const fetchBanners = () => {
    setLoadingBannersSlides(true);
    const oldResponse = getFromStorage(banners);
    if (oldResponse) updateBannersSlides(oldResponse);
    setLoadingBannersSlides(false);
    return oldResponse ?? [];
  };
  // Extra Points
  const [loadingExtraPoints, setLoadingExtraPointsCards] = useState(false);
  const [extraPoints, updateExtraPoints] = useState([]);
  const fetchExtras = () => {
    setLoadingExtraPointsCards(true);
    const oldResponse = getFromStorage(extras);
    if (oldResponse) updateExtraPoints(oldResponse);
    setLoadingExtraPointsCards(false);
    return oldResponse ?? [];
  };
  // Rewards
  const [loadingRewards, setLoadingRewardsCards] = useState(false);
  const [rewardsCards, updateRewardsCards] = useState([]);
  const fetchRewards = () => {
    setLoadingRewardsCards(true);
    const oldResponse = getFromStorage(rewards);
    if (oldResponse) updateRewardsCards(oldResponse);
    setLoadingRewardsCards(false);
    return oldResponse ?? [];
  };
  // Awards
  const [loadingAwards, setLoadingAwardsCards] = useState(false);
  const [awardsCards, updateAwardsCards] = useState([]);
  const fetchAwards = () => {
    setLoadingAwardsCards(true);
    const oldResponse = getFromStorage(awards);
    if (oldResponse) updateAwardsCards(oldResponse);
    setLoadingAwardsCards(false);
    return oldResponse ?? [];
  };

  useEffect(() => {
    const initDash = async () => {
      const oldBanners = fetchBanners();
      const oldStamps = fetchStamps();
      const oldExtras = fetchExtras();
      const oldRewards = fetchRewards();
      const oldAwards = fetchAwards();
      const oldStars = fetchStars();
      try {
        await Promise.allSettled([
          getStampsCards().then((newResponse) => {
            const areEquals = compareArrays(newResponse, oldStamps);
            if (!areEquals || oldStamps.length === 0) {
              setLoadingStamps(true);
              putInStorage(stamps, newResponse);
              updateStampsCards(newResponse);
              setLoadingStamps(false);
            }
          }),
          getBannersSlides().then((newResponse) => {
            const areEquals = compareArrays(newResponse, oldBanners);
            if (!areEquals || oldBanners.length === 0) {
              setLoadingBannersSlides(true);
              putInStorage(banners, newResponse);
              updateBannersSlides(newResponse);
              setLoadingBannersSlides(false);
            }
          }),
          getExtraPointsCards().then((newResponse) => {
            const areEquals = compareArrays(newResponse, oldExtras);
            if (!areEquals || oldExtras.length === 0) {
              setLoadingExtraPointsCards(true);
              putInStorage(extras, newResponse);
              updateExtraPoints(newResponse);
              setLoadingExtraPointsCards(false);
            }
          }),
          getRewardsCards().then((newResponse) => {
            const areEquals = compareArrays(newResponse, oldRewards);
            if (!areEquals || oldRewards.length === 0) {
              setLoadingRewardsCards(true);
              putInStorage(rewards, newResponse);
              updateRewardsCards(newResponse);
              setLoadingRewardsCards(false);
            }
          }),
          getAwardsCards().then((newResponse) => {
            const areEquals = compareArrays(newResponse, oldAwards);
            if (!areEquals || oldAwards.length === 0) {
              setLoadingAwardsCards(true);
              putInStorage(awards, newResponse);
              updateAwardsCards(newResponse);
              setLoadingAwardsCards(false);
            }
          }),
          getStarsCards().then((newResponse) => {
            const fixed = Object.values(newResponse);
            const areEquals = compareArrays(fixed, oldStars);
            if (!areEquals || oldStars.length === 0) {
              setLoadingStars(true);
              putInStorage(stars, fixed);
              updateStarsCards(fixed);
              setLoadingStars(false);
            }
          }),
        ]);
      } catch (e) {
        console.error(e);
      }
    };
    initDash();
  }, []);

  const compareArrays = (a, b) => JSON.stringify(a) === JSON.stringify(b);

  const LinkToPath = ({ path = "/", sendEvent = null }) => {
    return (
      <>
        <div className="know-more-button">
          <Link
            to={`${path}?${tokenSolver()}`}
            onClick={() => {
              if (gtm && sendEvent) sendTag(gtm, sendEvent);
            }}
          >
            Mostrar más
          </Link>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="dashboard-page">
        <div className="welcome-hero-banner">
          <CoalitionHeroBanner balance={balance} onClickEvent={goToMovements} />
        </div>

        {loadingStars ? (
          <CoalitionSpinner />
        ) : (
          <div className="normal-block">
            <StarsBlock stars={starsCards} />
            {!starsCards || starsCards.length === 0 ? null : (
              <LinkToPath path="/stars" sendEvent={event_properties_101_07()} />
            )}
          </div>
        )}

        {loadingStamps ? (
          <CoalitionSpinner />
        ) : (
          <div className="normal-block">
            <StampsBlock stamps={stampsCards} />
            {!stampsCards || stampsCards.length === 0 ? null : (
              <LinkToPath path="/stamps" />
            )}
          </div>
        )}
        {loadingBannersSlides ? (
          <CoalitionSpinner />
        ) : (
          <div className="normal-block">
            <BannersBlock banners={bannersSlides} />
          </div>
        )}
        {loadingExtraPoints ? (
          <CoalitionSpinner />
        ) : (
          <div className="normal-block">
            <ExtrasBlock extraPoints={extraPoints} />
            {!extraPoints || extraPoints.length === 0 ? null : (
              <LinkToPath path="/extras" />
            )}
          </div>
        )}
        {loadingRewards ? (
          <CoalitionSpinner />
        ) : (
          <div className="normal-block">
            <RewardsBlock rewards={rewardsCards} />
            {!rewardsCards || rewardsCards.length === 0 ? null : (
              <LinkToPath path="/rewards" />
            )}
          </div>
        )}
        {loadingAwards ? (
          <CoalitionSpinner />
        ) : (
          <div className="normal-block">
            <AwardsBlock awards={awardsCards} balance={balance} />
            {!awardsCards || awardsCards.length === 0 ? null : (
              <LinkToPath path="/awards" />
            )}
          </div>
        )}
      </div>
    </>
  );
};
